import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0.8em;
	margin-left: 2em;
`;
